import CustomForm from '../../lib/FormValidator/Form/CustomForm';
import { OficialOfflineAssertions } from '../../system/PlanillaPartidoOffline/OficialOfflineAssertions';

class OficialOfflineForm extends CustomForm {
  protected constructor(
    ofio_id: string | null,
    ofio_tipo_doc: string,
    ofio_nro_doc: string,
    ofio_nombre: string,
    ofio_apellido: string
  ) {
    const ofioff = OficialOfflineAssertions.build();
    super('OficialOffline', ofioff);
    this.addInputAsserted('ofio_id', ofio_id);
    this.addInput('ofio_tipo_doc', ofio_tipo_doc);
    this.addInput('ofio_nro_doc', ofio_nro_doc);
    this.addInput('ofio_nombre', ofio_nombre);
    this.addInput('ofio_apellido', ofio_apellido);
  }

  private static build(
    ofio_id: string | null,
    ofio_tipo_doc: string,
    ofio_nro_doc: string,
    ofio_nombre: string,
    ofio_apellido: string
  ) {
    return new this(ofio_id, ofio_tipo_doc, ofio_nro_doc, ofio_nombre, ofio_apellido);
  }

  static initialize() {
    return this.build(null, '', '', '', '');
  }

  getIdInput() {
    return this.getInputByName('ofio_id');
  }

  getTipoDocInput() {
    return this.getInputByName('ofio_tipo_doc');
  }

  getNroDocInput() {
    return this.getInputByName('ofio_nro_doc');
  }

  getNombreInput() {
    return this.getInputByName('ofio_nombre');
  }

  getApellidoInput() {
    return this.getInputByName('ofio_apellido');
  }
}

export default OficialOfflineForm;
